export default (state = {isMentee: false}, action) => {
    if(action.type === 'isMentee') {
        state['isMentee'] = action['isMentee'];
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/user.js